export interface ProjectModel {
    code: string;
    name: string;
    companyCode: string;
    documentParserSettings: DocumentParserSettingsModel;
    users: ProjectUserModel[];
    roles: ProjectRoleModel[];
}

export interface DocumentParserSettingsModel {
    originator: ParserSettingItemModel[];
    volume: ParserSettingItemModel[];
    level: ParserSettingItemModel[];
    documentType: ParserSettingDocumentTypeItemModel[];
    classification: ParserSettingItemModel[];
    role: ParserSettingItemModel[];
    fileExtension: ParserSettingItemModel[];
    systemRoleMapping: ParserRoleMappingModel[];
    attributeDisplayMapping: Record<ParserAttributeDisplayMapping, string>;
}

export enum ParserAttributeDisplayMapping {
    Originator = 'originator',
    Volume = 'volume',
    Level = 'level',
    DocumentType = 'documentType',
    Role = 'role',
    Classification = 'classification',
    FileExtension = 'fileExtension',
}

export interface ParserSettingItemModel {
    guid: string;
    key: string;
    display: string;
}

export interface ParserSettingDocumentTypeItemModel extends ParserSettingItemModel {
    allowClassification: boolean;
}

export interface ProjectRoleModel {
    guid: string;
    key: string;
    display: string;
    color: string;
}

export interface ProjectUserModel {
    guid: string;
    email: string;
    firstName: string;
    middleName: string | null;
    lastName: string;
    companyCode: string;
    companyGuid: string;
    roleCode: string;
    roleGuid: string;
    status: string;
}

export interface ParserRoleMappingModel {
    systemRole: string;
    systemRoleGuid: string;
    parserRole: string;
    parserRoleGuid: string;
}